import {useTranslation} from 'react-i18next';
import {PaymentListDataContext} from '../PaymentListDataContext';
import {Grid, makeStyles, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from '@material-ui/core';
import TableHeader from '../../../components/table/TableHeader';
import PaymentRow from './PaymentRow';
import TablePagination from '../../../components/table/Pagination';
import {Skeleton} from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import React, {useContext} from 'react';

type PaymentTableProps = {
  showPagination: Boolean;
};

const useStyles = makeStyles((theme) => ({
  skeleton: {
    height: '200px',
  },
  main: {
    padding: theme.spacing(1),
  },
}));

const PaymentsTable = ({ showPagination }: PaymentTableProps) => {
  const { t } = useTranslation('payments');

  const classes = useStyles();

  const context = useContext(PaymentListDataContext);
  const preColumns = !context.isPrefilteredForCustomer
    ? [
        {
          label: t('status'),
          id: 'state',
        },
        {
          label: t('customer'),
          id: 'debitor',
        },
      ]
    : [
        {
          label: t('status'),
          id: 'state',
        },
      ];

  const columns = preColumns.concat([
    {
      label: t('purpose'),
      id: 'purpose',
    },
    {
      label: t('amount'),
      id: 'amount',
    },
    {
      label: t('payment method'),
      id: 'paymentMethod',
    },
    {
      label: t('creationDate'),
      id: 'createdDateTimeUTC',
    },
    {
      label: t('completion'),
      id: 'complete',
    },
  ]);

  const initialLoad = !context.page && context.loading;
  const emptyResultList = !!context.page && context.payments.length === 0;
  const emptyFilteredResultList = emptyResultList && context.filters?.used;

  return (
    <>
      {emptyResultList ? (
        <>
          {emptyFilteredResultList ? (
            <Typography style={{ marginTop: '40px' }}>{t('no results for your search')}</Typography>
          ) : (
            <Grid item xs={12} className={classes.main}>
              <MuiAlert elevation={6} variant="filled" severity="warning">
                {t('no payments linked')}
              </MuiAlert>
            </Grid>
          )}
        </>
      ) : (
        <>
          <TableContainer style={{ flex: '1 1 auto' }}>
            <Table>
              <TableHeader columns={columns} actions={true}></TableHeader>
              <TableBody>
                {initialLoad && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1}>
                      <Skeleton className={classes.skeleton} />
                    </TableCell>
                  </TableRow>
                )}
                {context.payments?.map((payment, index) => (
                  <PaymentRow payment={payment} index={index} key={payment.id}></PaymentRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {showPagination && <TablePagination transformPageSizeLabel={(pageSize) => t('pageSize', { pageSize: pageSize }) as string} />}
        </>
      )}
    </>
  );
};

export default PaymentsTable;
